import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LegalPageLayoutComponent, LegalSection } from '../../../components/legal/legal-page-layout/legal-page-layout';

@Component({
  selector: 'app-community-guidelines',
  standalone: true,
  imports: [LegalPageLayoutComponent, RouterLink],
  templateUrl: './community-guidelines.html',
})
export class CommunityGuidelines {
  sections: LegalSection[] = [
    { id: 'introduction', label: 'Introduction' },
    { id: 'how-we-moderate', label: 'How We Moderate Content' },
    { id: 'reporting-content', label: 'Reporting Content' },
    { id: 'investigation-process', label: 'Investigation Process' },
    { id: 'possible-outcomes', label: 'Possible Outcomes' },
    { id: 'illegal-content', label: 'Illegal Content' },
    { id: 'emergency-action', label: 'Emergency Action' },
    { id: 'fraud-prevention', label: 'Fraud Prevention' },
    { id: 'fairness-consistency', label: 'Fairness and Consistency' },
    { id: 'appeals', label: 'Appeals' },
    { id: 'false-malicious-reports', label: 'False or Malicious Reports' },
    { id: 'confidentiality', label: 'Confidentiality' },
    { id: 'cooperation-authorities', label: 'Cooperation with Authorities' },
    { id: 'continuous-improvement', label: 'Continuous Improvement' },
    { id: 'our-commitment', label: 'Our Commitment' },
  ];
}
